module.exports = __webpack_public_path__ + "img/vue-logo.7401e05b.png";